// const getCitationMarkers = (mode, styles, ace) => {
//     let txt;
//     var className;
//     let typ;
//     if (mode === "image") {
//         txt = /(Fig|Figure)\.*~*\\ref{(.*?)}/gi;
//         className = styles.reference;
//     } else if (mode === "Table") {
//         txt = /Table\.*~*\\ref{(.*?)}/gi;
//         className = styles.table_cit;
//     } else if (mode === "equation") {
//         txt = /(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){(.*?)}\)*/gi;
//         className = styles.equ_cit;
//     } else {
//         txt = /\\cite{(.*?)}/gi;
//         className = styles.citation;
//     }

import { logDOM } from "@testing-library/react";

//     if (ace.current.editor) {
//         ace.current.editor.$search.$options = {
//             needle: txt,
//             wrap: true,
//             caseSensitive: false,
//             wholeWord: false,
//             regExp: true,
//             preventScroll: true, // do not change selection
//         };
//     }
//     var res = ace.current.editor.$search.findAll(ace.current.editor.session);
//     var allMarkers = [];
//     for (var r of res) {
//         var text = ace.current.editor.session.getTextRange(r);
//         if (/(Fig|Figure)\.*~*\\ref{/i.test(text)) {
//             typ = text.match(/(Fig|Figure)\.*~*\\ref{/i);
//             text = text
//                 .replace(/(Fig|Figure)\.*~*\\ref{/i, "")
//                 .replace(/\}\)*/, "");
//         } else if (/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i.test(text)) {
//             typ = text.match(/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i);
//             text = text
//                 .replace(/(equation|eq|eqs)*\.*~*\(*(\\ref|\\eqref){/i, "")
//                 .replace(/\}\)*/, "");
//         } else if (/Table\.*~*\\ref{/i.test(text)) {
//             typ = text.match(/Table\.*~*\\ref{/i);
//             text = text.replace(/Table\.*~*\\ref{/i, "").replace(/\}\)*/, "");
//         } else if (/\\cite{/i.test(text)) {
//             typ = text.match(/\\cite{/i);
//             text = text.replace(/\\cite{/i, "").replace(/\}\)*/, "");
//         } else {
//         }
//         var tend = text.length;
//         var commaSeparated = text.split(",");
//         var st = typ[0].length;

//         // console.log(r);
//         var end = 0;
//         for (var i = 0; i < commaSeparated.length; i++) {
//             end += commaSeparated[i].length;
//             allMarkers.push({
//                 startRow: r.start.row,
//                 startCol: r.start.column + st,
//                 endRow: r.end.row,
//                 endCol: r.end.column - (tend - (end - 1) - i),
//                 className: className,
//                 type: "text",
//                 text: commaSeparated[i].trim(),
//             });
//             st = st + commaSeparated[i].length + 1;
//         }
//     }
//     return allMarkers;
// };

const getCitationMarkers = (styles, ace) => {
    if (!ace.current.editor) return [];

    const editor = ace.current.editor;
    // Combined regex for all citation types
    const combinedRegex = /(Fig|Figure)\.*~*\\ref{(.*?)}|(Table)\.*~*\\ref{(.*?)}|((equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){(.*?)}\)*)|~\\cite{(.*?)}/gi;

    // editor.$search.$options = {
    //     needle: combinedRegex,
    //     wrap: true,
    //     caseSensitive: false,
    //     wholeWord: false,
    //     regExp: true,
    //     preventScroll: true,
    // };
    let lines = ace.current.editor.session.getDocument().getAllLines(); //array of lines 
    let fullText = lines.join("\n"); //array to whole tex 
    //console.log(fullText);
    let results = [];
    let match;
    const allMarkers = [];

    while ((match = combinedRegex.exec(fullText)) !== null) {
        const startIndex = match.index;
        const endIndex = startIndex + match[0].length;

        const startPos = indexToPos(startIndex, lines);
        const endPos = indexToPos(endIndex, lines);

        results.push({
            start: startPos,
            end: endPos
        });
    } 

    function indexToPos(index, lines) {
        let row = 0;
        let remaining = index;

        while (row < lines.length && remaining > lines[row].length) {
            remaining -= (lines[row].length + 1); // +1 for newline
            row++;
        }
        return {
            row: row,
            column: remaining
        };
    }

    for (let r of results) {
        let text = editor.session.getTextRange(r);
        let typeMatch, className;

        if (/(Fig|Figure)\.*~*\\ref{/i.test(text)) {
            typeMatch = text.match(/(Fig|Figure)\.*~*\\ref{/i);
            className = styles.reference;
            text = text.replace(/(Fig|Figure)\.*~*\\ref{/i, "").replace(/\}\)*/, "");
        } else if (/Table\.*~*\\ref{/i.test(text)) {
            typeMatch = text.match(/Table\.*~*\\ref{/i);
            className = styles.table_cit;
            text = text.replace(/Table\.*~*\\ref{/i, "").replace(/\}\)*/, "");
        } else if (/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i.test(text)) {
            typeMatch = text.match(/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i);
            className = styles.equ_cit;
            text = text.replace(/(equation|eq|eqs)*\.*~*\(*(\\eqref|\\ref){/i, "").replace(/\}\)*/, "");
        } else if (/\\cite{/i.test(text)) {
            typeMatch = text.match(/\\cite{/i);
            className = styles.citation;
            text = text.replace(/\\cite{/i, "").replace(/\}\)*/, "");
        }

        const tend = text.length;
        const commaSeparated = text.split(",");
        let st = typeMatch[0].length;
        let end = 0;

        for (let i = 0; i < commaSeparated.length; i++) {
            end += commaSeparated[i].length;
            allMarkers.push({
                startRow: r.start.row,
                startCol: r.start.column + st,
                endRow: r.end.row,
                endCol: r.end.column - (tend - (end - 1) - i),
                className,
                type: "text",
                text: commaSeparated[i].trim(),
            });
            st = st + commaSeparated[i].length + 1;
        }
    }

    return allMarkers;
};


const getInlineEqnMarkers = (ace, styles) => {
    ace.current.editor.$search.$options = {
        needle: "\\$(.*?)\\$",
        wrap: true,
        caseSensitive: false,
        wholeWord: false,
        regExp: true,
        preventScroll: true, // do not change selection
    };
    var res = ace.current.editor.$search.findAll(ace.current.editor.session);
    var allMarkers = [];
    for (var r of res) {
        var text = ace.current.editor.session.getTextRange(r);
        text = text.replace(/\$/g, "");
        allMarkers.push({
            startRow: r.start.row,
            startCol: r.start.column + 1,
            endRow: r.end.row,
            endCol: r.end.column - 1,
            className: styles.inline_equation,
            type: "text",
            text: text,
        });
    }
    return allMarkers;
};

const getEqnMarkers = (ace, styles) => {
    var maxLines = 10;
    ace.current.editor.$search.$options = {
        needle: /\\begin\{eq.*/g,
        wrap: true,
        caseSensitive: false,
        wholeWord: false,
        regExp: true,
        preventScroll: true, // do not change selection
    };
    var res = ace.current.editor.$search.findAll(ace.current.editor.session);
    var allMarkers = [];
    for (var r of res) {
        var found = false;
        var text = ace.current.editor.session.getTextRange(r);
        //ace.current.editor.session.getTextRange({start:{row:5}, end:{row:5}})
        for (var i = 1; i < maxLines; i++) {
            var curText = ace.current.editor.session.getLine(r.start.row + i);
            text += "\r\n" + curText;
            if (curText.indexOf("\\end") === 0) {
                found = true;
                break;
            }
        }
        if (found) {
            allMarkers.push({
                startRow: r.start.row,
                startCol: r.start.column,
                endRow: r.start.row + i,
                endCol: curText.length,
                className: styles.equation,
                type: "text",
                text: text,
            });
        }
    }
    return allMarkers;
};

export {
    getCitationMarkers,
    getInlineEqnMarkers,
    getEqnMarkers
}